import { render } from "./BtnOptionFeedback.vue?vue&type=template&id=675cc809&scoped=true"
import script from "./BtnOptionFeedback.vue?vue&type=script&lang=js"
export * from "./BtnOptionFeedback.vue?vue&type=script&lang=js"

import "@/css/components/btn-option-feedback.css?vue&type=style&index=0&id=675cc809&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675cc809"]])

export default __exports__